module.exports = __webpack_public_path__ + "img/topicDomesticChemicals.a63340eb.webp";